import React from 'react';

const SeleccionModo = ({ setModo, modosDesbloqueados, volverACategoria, quizzesCompletados }) => {
  const modos = [
    { nombre: 'Clásico', siempreDisponible: true },
    { nombre: 'Sin fallos', siempreDisponible: false },
    { nombre: 'Contrarreloj', siempreDisponible: false }
  ];

  return (
    <div className="seleccion-modo">
      <h2>Selecciona un modo de juego</h2>
      {!modosDesbloqueados && (
        <p>Completa {3 - quizzesCompletados} quizzes más en modo Clásico en esta categoría para desbloquear los modos "Sin fallos" y "Contrarreloj".</p>
      )}
      <div className="modos">
        {modos.map((modo) => (
          <button 
            key={modo.nombre} 
            onClick={() => modo.siempreDisponible || modosDesbloqueados ? setModo(modo.nombre) : null}
            disabled={!modo.siempreDisponible && !modosDesbloqueados}
            className={(!modo.siempreDisponible && !modosDesbloqueados) ? 'bloqueado' : ''}
          >
            {modo.nombre}
            {!modo.siempreDisponible && !modosDesbloqueados && " (Bloqueado)"}
          </button>
        ))}
      </div>
      <button onClick={volverACategoria} className="boton-volver">Volver</button>
    </div>
  );
};

export default SeleccionModo;
